<template src="./Actions.html" />

<script>
import { computed } from "vue"
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"
import NewSchedule from "../NewSchedule/NewSchedule.vue"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"
import { reasonsList } from "@/constants/reasons-for-inativation"

export default {
  mixins: [mixins],
  components: {
    NewSchedule,
    WholeMultiselect,
  },
  props: {
    patient: {
      type: Object,
      required: true,
    },
    onlyIcon: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      popupScheduleAppointment: false,
      showPopupresendWelcome: false,
      popupCancel: false,
      inactiveDescription: "",
      employeeEnabled: null,
      description: null,
      reason: null,
      alreadOnFreemium: false,
      message: "",
    };
  },

  computed: {
    isRequiredDescription() {
      return this.reason && this.reason.showReason
    },
    isButtonConfirmatioDisabled() {
      return !this.reason || !this.inactiveDescription && this.reason && this.reason.requiredDescription || this.alreadOnFreemium
    }
  },

  setup() {
    const store = useStore()

    return {
      reasonsList: reasonsList.filter((reason) => reason.show),
      isMobile: computed(() => store.getters.isMobile),
    }
  },

  watch: {
    reason(val) {
      this.alreadOnFreemium = !!val && val.name !== "Insatisfação" && !!(this.alreadOnFreemium || this.message)
    },
  },
  
  methods: {
    init() {
      this.getSpecialties()
    },

    resetModal() {
      this.popupCancel = false
      this.reason = null
      this.message = ""
      this.alreadOnFreemium = false
    },

    schedulePatient() {
      this.popupScheduleAppointment = true
    },

    mapUrlQuiz() {
      window.open(this.patient.urlQuiz)
    },
    resendEmailAlert() {
      this.showPopupresendWelcome = true
    },

    resendWelcome() {
      this.axios.post(
        `${this.$store.state.filooServer}consultant/patients/${this.patient.id}/quiz`,
        this.patient,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
      .then((response) => {
        if (response.status === 200) {
          this.showPopupresendWelcome = false
          this.$swal({
            title: "Sucesso!",
            text: "Operação realizada com sucesso! O e-mail de boas vindas foi enviado para o paciente.",
            icon: "success"
          })
            .then(() => this.getCustomers())
        }
      })
      .catch(() => {
        this.showPopupresendWelcome = false
        this.$swal({
          title: "Atenção!",
          text: "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
          icon: "error"
        })
      })
    },
    saveInactivePatientHistory() {
      this.alreadOnFreemium = this.patient.isFreemium && this.reason.name !== "Insatisfação"

      if (this.alreadOnFreemium) {
        this.message = "Assinante já está ativo em uma assinatura freemium."
      } else {
        this.description = this.reason.name === "Outro"
          ? this.reason.name
          : `${this.reason.name}: ${this.inactiveDescription}`
  
        this.axios.post(
          `${this.$store.state.filooServer}history-inactivate/inactivate`,
          { patientId: this.patient.id, description: this.description },
          { headers: { Authorization: this.$session.get("bearer") }},
        )
          .then((response) => {
            if (response.status === 200) {
              if (this.patient.isFreemium && this.reason.name === "Insatisfação") {
                this.message = "Sucesso! Status atualizado."
              }
              this.changeStatus()
            }
          })
          .catch(() => {})
      }
    },
    changeStatus() {
      this.$vs.loading();
      const inactivateClient = {
        id: this.patient.id,
        reasonDeactivation: this.reason ? this.reason.name : null,
        descriptionDeactivation: this.inactiveDescription,
      }
      this.popupCancel = false

      this.axios.put(
        this.$store.state.filooServer +
          "company/changeStatus", inactivateClient,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.inactiveDescription = ""
            this.description = null
            this.reason = null

            this.$swal({
              title: "Sucesso!",
              text: "Status atualizado",
              icon: "success"
            })
              .then(() => this.$emit('update-status'))
          }
        })
        .catch(() => {
          this.$vs.loading.close()

          this.$swal({
            title: "Atenção!",
            text: `Não foi possível executar esta operação.Por favor, tente
              novamente ou entre em contato com o administrador do sistema.`,
            icon: "error"
          })
        })
    },
  }
};
</script>

<style lang="scss" src="./Actions.scss" />
